// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-prices{background-color:#fff;background-color:hsla(0,0%,100%,.8);bottom:0;font-size:12px;left:0;padding:0 3px;position:absolute}.info-prices,.leaflet-popup:hover{z-index:10000}@media(prefers-color-scheme:dark){.leaflet-control-attribution,.leaflet-control-zoom-in,.leaflet-control-zoom-out,.leaflet-layer{filter:invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
